import React from 'react';
import { NavLink } from 'react-router-dom';

import CardActions from '@material-ui/core/CardActions';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';

import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';

export default function PodcastCardLinks(props) {
  return (
    <CardActions>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        width={1}
        px={1}
        height={37}
      >
        <Box>
          {props.pdf && (
            <IconButton href={props.pdf} color='secondary' download>
              <SaveAltOutlinedIcon />
            </IconButton>
          )}
        </Box>
        <NavLink to={props.link}>
          <Button color='secondary'>{props.buttontext}</Button>
        </NavLink>
      </Box>
    </CardActions>
  );
}
